<template>
  <div>
    <b-table
      show-empty
      hover
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      @row-selected="onRowSelected"
      responsive="sm"
      :busy="loading"
      :items="getInfo"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      head-variant="light"
      class="bg-white"
    ></b-table>
    <b-row class="mx-auto">
      <b-col md="4" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
      <b-col md="4" class="mx-auto"></b-col>
      <b-col md="4" align="right" class="px-0">
        <b-pagination
          align="right"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      fields: [
        {
          key: "created_at_date_only",
          label: "Created",
          sortable: true,
          class: "text-left"
        },
        {
          key: "shipment_code",
          label: "Shipment Code",
          sortable: true,
          class: "text-center"
        },
        {
          key: "extra_packaging_name",
          label: "Name",
          sortable: true,
          class: "text-center"
        },
        {
          key: "qty_extra_packaging_to_buy",
          label: "Qty",
          sortable: true,
          class: "text-center"
        },
        {
          key: "note",
          label: "Note",
          sortable: true,
          class: "text-center"
        }
      ]
    };
  },
  methods: {
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      this.$store
        .dispatch("ExtraPackagingModule/getExtraPackagingLogs", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch(error => {
          this.isBusy = false;
          callback([]);
        });
      return null;
    }
  }
};
</script>

<style>
</style>